export const portfolioCreationEndpoints = (builder) => ({
    updatePortfolioCreation: builder.mutation({
        query: ({ id, userId, paymentStatus, accountFundStatus, status, meta }) => ({
            url: `/portfolio-creation/${id}`,
            method: 'patch',
            body: {
                userId,
                paymentStatus, 
                accountFundStatus, 
                status,
                meta
            }
        }),
    }),
    downloadPortfolioCreationReport: builder.mutation({
        query: ({  userGroup, status, format, startDate, endDate }) => ({
            url: `/portfolio-creation/report/${format}?userGroup=${userGroup || ""}`
                + `&status=${status || ""}`
                + `&startDate=${startDate || ""}`
                + `&endDate=${endDate || ""}`,  
            method: 'post'
        }),
    }),
    
})